import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestTransferAccountRegister from './request/requestTransferAccountRegister'
import requestTransferAccountEdit from './request/requestTransferAccountEdit'

const Actions = {
  // TA01 振込口座取得
  getTransferAccountListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.TRANSFER_ACCOUNT_LIST)
      .get(api.TRANSFER_ACCOUNT_LIST)
      .then((response) => {
        const path = mutationsTypes.TRANSFER_ACCOUNT_SET_TRANSFER_ACCOUNT_LIST
        commit(path, response.data.data)

        const getData = getters.getTransferAccountListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // TA02 振込口座登録
  registerTransferAccount: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestTransferAccountRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.TRANSFER_ACCOUNT_REGISTER_EDIT)
      .post(api.TRANSFER_ACCOUNT_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // TA03 振込口座編集
  editTransferAccount: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestTransferAccountEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.TRANSFER_ACCOUNT_REGISTER_EDIT)
      .patch(`${api.TRANSFER_ACCOUNT_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // TA04 振込口座削除
  deleteTransferAccount: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      .patch(`${api.TRANSFER_ACCOUNT_DELETE}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
